import * as React from "react";
import { api, user } from "src/services/api";
import { classNames } from "src/services/theme";
import { FormState, Form, Fieldset, bindToAPI, resetState, _ } from "src/services/form";
import { Formatters, Loading, Modal } from "src/components/ui";

interface Props {
  ordini?: any;
  abbonamenti?: any;
  adsp?: any;
  onRicaricaCrediti: Function;
}

interface State {
}

export default class Acquisti extends React.Component<Props, State> {
  
  render() {
    const { ordini, abbonamenti, adsp, onRicaricaCrediti } = this.props;
    const { } = this.state;
    return (
      <div className="ecommerce_Acquisti">
        <header>
          <h2>I tuoi acquisti</h2>
        </header>
        {!ordini && !abbonamenti && !adsp &&
        <div className="none">
          Non hai ancora acquistato nessun servizio.
        </div>
        }
        {ordini.length > 0 &&
        <section>
          <h3>Acquisto pacchetti crediti</h3>
          <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data</th>
              <th>Q.tà crediti</th>
              <th>Prezzo</th>
              <th>Ricevuta</th>
            </tr>
          </thead>
          <tbody>
            {ordini.map( (i, k) => {
            const crediti = i.prodotti[0];
            return (
              <tr key={k}>
                <td>{i.id}</td>
                <td>{Formatters.Date({date: i.created_at})}</td>
                <td>{crediti.crediti}</td>
                <td>{Formatters.Price({val: i.totale})}</td>
                <td />
              </tr>
            )
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={5}>
                <div>
                  <article>
                    <strong>Il tuo saldo crediti</strong>
                    <span>{user.crediti}</span>
                  </article>
                  <div>
                    <button className="main md" onClick={() => onRicaricaCrediti()}><span>Acquista crediti</span></button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
          </table>
        </section>
        }
        
        {abbonamenti.length > 0 &&
        <section>
          <h3>Acquisto abbonamenti</h3>
          <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data da</th>
              <th>Data a</th>
              <th>Abbonamento</th>
              <th>Prezzo</th>
              <th>Ricevuta </th>
            </tr>
          </thead>
          <tbody>
            {abbonamenti.map( (i, k) => {
            return (
              <tr key={k}>
                <td>{i.id}</td>
                <td>{Formatters.Date({date: i.data_inizio})}</td>
                <td>{Formatters.Date({date: i.data_sospensione})}</td>
                <td>{i.tipologia.nome }</td>
                <td>{i.prezzo}</td>
                <td />
              </tr>
            )
            })}
          </tbody>
          </table>
        </section>
        }
        
        {adsp.length > 0 &&
        <section>
          <h3>Acquisto servizi</h3>
          <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Periodo</th>
              <th>Servizio</th>
              <th>Crediti</th> 
              <th>Dettaglio </th>
            </tr>
          </thead>
          <tbody>
            {adsp.map( (i, k) => {
            return (
              <tr key={k}>
                <td>{i.id}</td>
                <td>
                  {Formatters.Date({date: i.DataInizio})}
                  &nbsp;-&nbsp;
                  {Formatters.Date({date: i.DataFine})}
                </td>
                <td>
                {i.tipo === "ADSP" ? "Vetrina" : "Ad Words"}
                </td>
                <td>{i.prezzo}</td>
                <td />
              </tr>
            )
            })}
          </tbody>
          </table>
        </section>
        }
        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/Acquisti.tsx